import React, { useEffect, useState } from 'react'
import { Heading, Button, Flex } from '@liquidcollectibles/uikit'
import { useTranslation } from 'contexts/Localization'
import { Link } from 'react-router-dom'
import { useGetCollectionMetadata } from 'state/collectibles/hooks'
import styled from 'styled-components'
import NftList from 'views/Collectibles/components/NftList'
import { fetchCollectibles } from 'hooks/licoApi'
import { NftMetadata } from 'config/constants/types'

const Container = styled.div`
  width: 100%;
`

const Showcase = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledLink = styled(Link)`
  width: 100%;

  ${({ theme }) => theme.mediaQueries.lg} {
    width: 40%;
  }
`

const Title = styled(Heading)`
  text-align: center;
  margin-bottom: 16px;
  font-size: 24px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 48px;
  }
`

const Subtitle = styled(Heading)`
  text-align: center;
  margin-bottom: 24px;
  font-size: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 24px;
  }
`

const limoAddress = '0x0d464bdde2301c30871bb4c29bb7dd935f5a985c'

const ShowCase = () => {
  const { t } = useTranslation()
  const [data, setData] = useState<NftMetadata[]>()
  const collection = useGetCollectionMetadata(limoAddress)
  const limit = 500

  useEffect(() => {
    const getMetadata = async () => {
      const randomSkip = Math.floor(Math.random() * 6000)
      const response = await fetchCollectibles(limoAddress, randomSkip, limit)
      const shuffled = response.sort(() => 0.5 - Math.random())
      const randomLimos = shuffled.slice(0, 3)

      setData(randomLimos)
    }

    getMetadata()
  }, [])

  return (
    <>
      <Container>
        <Title>{t('Discover our Liquid Monsters')}</Title>
        <Subtitle>{t('Pick yours')}</Subtitle>
        {collection && data && (
          <Showcase>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <NftList showSwap={false} collectionNfts={collection} nftsList={data} isHomeView />
            </div>
            <Flex mt="24px" justifyContent="center">
              <StyledLink to={`/collection/${collection.nftAddress}`}>
                <Button variant="primary" width="100%">
                  View Collection
                </Button>
              </StyledLink>
            </Flex>
          </Showcase>
        )}
      </Container>
    </>
  )
}

export default ShowCase
